// extracted by mini-css-extract-plugin
module.exports = {"policyLink":"_2zZx-hopCz79Oq8VsC28yF"};